export default __webpack_public_path__ + "static/ehm-hair-treatment-65e7741ce94c509839541967e3572ac0.webp";